import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useLiveFormEditorContext } from "@/features/LiveFormEditor/common/LiveFormEditorContext";

export const useShouldShowCustomMessagesDisabledBanner = (): boolean => {
  const { organization } = useCurrentUserContext();
  const { apiFormObject, editOrCreateMode, editorMode } = useLiveFormEditorContext();

  return (
    !organization?.paymentEnabledAtUtc &&
    editOrCreateMode === "edit" &&
    editorMode === "org" &&
    Boolean(apiFormObject.hasAtLeastOneCommand)
  );
};
